import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { bulkCodeService } from "../services/bulkCode";

export const getAllBulkCodes = createAsyncThunk(
	"bulk/codes/getAll",
	async (params = {}, { rejectWithValue }) => {
		try {
			const response = await bulkCodeService.getListCodes(params);
			return response.data;
		} catch (error) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const generateBulkCodes = createAsyncThunk(
	"bulk/code/generate",
	async (data, { rejectWithValue }) => {
		try {
			const response = await bulkCodeService.generateBulkCodes(data);
			return response;
		} catch (error) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

const initialState = {
	data: { bulkCodes: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 } },
	singleData: {},
	loading: false,
	error: false,
	message: "",
};

const slice = createSlice({
	name: "bulkcodes",
	initialState,
	reducers: {},
	extraReducers: {
		[getAllBulkCodes.pending]: (state) => {
			if (!state.data?.bulkCodes?.data?.length) {
				state.loading = true;
			}
		},
		[getAllBulkCodes.fulfilled]: (state, action) => {
			state.error = false;
			state.data = action.payload;
			state.loading = false;
		},
		[getAllBulkCodes.rejected]: (state, action) => {
			state.error = true;
			state.message = action.payload;
			state.loading = false;
		},

		[generateBulkCodes.pending]: (state) => {
			state.loading = true;
		},
		[generateBulkCodes.fulfilled]: (state, { payload }) => {
			state.message = payload?.message;
			state.loading = false;
			//
		},
		[generateBulkCodes.rejected]: (state, { payload }) => {
			state.error = true;
			state.message = payload;
			state.loading = false;
		},
	},
});

export default slice.reducer;
